import { mapState, mapMutations, mapActions } from "vuex";
import { fillAlicdnImagePre } from "@/utils/alicdnImage";
export default {
    data() {
        return {
            moreConfig: {
                showImagesType: 100,
                showDetailImage: false,
                imageSize: 0,
                skuSize: 0,
            }
        }
    },
    computed: {
        ...mapState("product", [
            "copyProductIdsBackup",
            "readConfig",
            "copyConfig",
            "copyProductIds",
            "copyLog",
            "copyLinkValue",
            "product",
            "pddProducts",
            "pddFilterId",
            "pddImportPath",
            "jumpProduct",

            "loading",
            "imageUploadLockDepth",
            "editIndex",
            "lastEditIndex",
            "hasEdited",
            "cacheDetail",
            "startTimestamp",
            "copyTime",

            "imgSelect",

            "selectShop",
            "shopList",
            "copyShopIds",

            "selectTemp",
            "tempList",
            "banJiaStatus",
            "banJiaProduct",
            "shangjiaproduct",
            "shangjiForm",
            "shangjiselection",
            "shangjiselectiononsale",
            "shangjistate",
            "shangjilog",
            "shangJiCollectState",
            "shangJiCollectLog",
            "shangjionsaleproducts",
            "huaShop",

            "titlestate",
            "title_products",
            "title_product_selects",
            "title_edit_rules",
            "titleLoadState",
            "titleLoadSnapshot",
            "titleLoadProgress",

            "skuPricestate",
            "sku_price_products",
            "sku_price_product_selects",
            "sku_price_edit_rules",
            "skuPriceLoadState",
            "skuPriceLoadSnapshot",
            "skuPriceLoadProgress",
            "skuPricePreviewState",
            "skuPriceStep",
            "skuPriceActiveProductId",

            "shorttitlestate",
            "short_title_products",
            "short_title_product_selects",
            "short_title_edit_rules",
            "shortTitleLoadState",
            "shortTitleLoadSnapshot",
            "shortTitleLoadProgress",

            "brandstate",
            "brand_products",
            "brand_product_selects",
            "brand_edit_rules",
            "brandLoadState",
            "brandLoadSnapshot",
            "brandLoadProgress",

            "aftersalestate",
            "aftersale_products",
            "aftersale_product_selects",
            "aftersale_edit_rules",
            "aftersaleLoadState",
            "aftersaleLoadSnapshot",
            "aftersaleLoadProgress",

            "attrstate",
            "attr_products",
            "attr_product_selects",
            "attr_edit_rules",

            "fabricstate",
            "fabric_products",
            "fabric_product_selects",
            "fabric_edit_rules",

            "freightstate",
            "freight_products",
            "freight_product_selects",
            "freight_edit_rules",

            "flashsalestate",
            "flashsaleCreateDialogVisible",
            "flashsaleCreateProgressTotal",
            "flashsaleCreateProgressDone",
            "flashsaleCreateSuccessCount",
            "flashsaleCreateFailCount",
            "flashsaleCreateStopRequested",
            "flashsaleCreateResults",
            "flashsale_products",
            "flashsale_product_selects",
            "flashsale_edit_form",
            "flashsale_load_running",
            "flashsale_load_status_text",
            "flashsale_load_page_info",
            "flashsale_load_gen",
            "flashsale_load_stop_flag",
            "flashsale_selected_shop_ids",
            "flashsale_shop_scan_cache",
        ]),

        _taobao() {
            return this.cacheDetail?.source_json_data || [];
        },
        _douyin() {
            // console.log("@@@@@@@@@@@@@@@@@cacheDetail", this.cacheDetail)
            return this.cacheDetail?.attr_json || [];
        },
        _defaultValue() {
            return this.cacheDetail?.change_attribute_json || {}
        }
    },
    methods: {
        ...mapMutations("product", [
            "SET_COPYLINK_VALUE",
            "RESET_PRODUCT_DATA",
            "RESET_PDD_PRODUCT_DATA",

            "REMOVE_PRODUCT",
            "removePddProduct",

            "UPDATE_PRODUCT_CATE",
            "UPDATE_PRODUCT_UNSETCATE",
            "UPDATE_PRODUCT_LOCK_STATUS_BY_IDS",
            "SET_EDIT_INDEX",
            "UPDATE_LOADING",
            "SET_CACHE_DETAIL",
            "SHOW_IMAGE_SELECT_AND_SET_FILED",
            "UPDATE_FILED_VALUE",
            "SET_COPY_TIME",
            "SET_COPY_START_TIMESTAMP",
            "SET_SELECT_SHOP",
            "SET_COPY_SHOP_IDS",
            "getCopyProductIds",
            "setShangJiProduct",
            "setShangJiForm",
            "setShangJiSelection",
            "addShangJiSelection",
            "delShangJiSelection",
            "setShangJiState",
            "setShangJiLog",
            "setShangJiCollectState",
            "setShangJiCollectLog",
            "setShangJiOnSaleProduct",
            "setShangJiSelectionOnSale",
            "addShangJiSelectionOnSale",
            "delShangJiSelectionOnSale",
            "setHuaShop",
            "delHuaShop",

            "setTitleProducts",
            "setTitleState",
            "getBatchEditTitlesStatus",
            "setTitleProductSelects",
            "addTitleProductSelects",
            "delTitleProductSelects",
            "setBatchEditTitleResult",
            "setTitleEditRule",

            "setSkuPriceProducts",
            "setSkuPriceState",
            "setSkuPricePreviewState",
            "setSkuPriceStep",
            "setSkuPriceActiveProductId",
            "setSkuPriceProductSelects",
            "setBatchEditSkuPriceResult",
            "setSkuPriceEditRule",
            "patchSkuPriceSku",

            "setShortTitleEditRule",
            "setBatchEditShortTitleResult",
            "setShortTitleProducts",
            "setShortTitleState",
            "setShortTitleProductSelects",
            "addShortTitleProductSelects",
            "delShortTitleProductSelects",

            "setBrandEditRule",
            "setBatchEditBrandResult",
            "setBrandProducts",
            "setBrandState",
            "setBrandProductSelects",
            "addBrandProductSelects",
            "delBrandProductSelects",

            "setAftersaleEditRule",
            "setBatchEditAftersaleResult",
            "setAftersaleProducts",
            "setAftersaleState",
            "setAftersaleProductSelects",
            "addAftersaleProductSelects",
            "delAftersaleProductSelects",

            "setAttrEditRule",
            "setBatchEditAttrResult",
            "setAttrProducts",
            "setAttrState",
            "setAttrProductSelects",
            "addAttrProductSelects",
            "delAttrProductSelects",

            "setFabricEditRule",
            "setBatchEditFabricResult",
            "setFabricProducts",
            "setFabricState",
            "setFabricProductSelects",
            "addFabricProductSelects",
            "delFabricProductSelects",

            "setFreightEditRule",
            "setBatchEditFreightResult",
            "setFreightProducts",
            "setFreightState",
            "setFreightProductSelects",
            "addFreightProductSelects",
            "delFreightProductSelects",

            "setFlashsaleEditRule",
            "setFlashsaleProducts",
            "setFlashsaleState",
            "setFlashsaleProductSelects",
            "addFlashsaleProductSelects",
            "delFlashsaleProductSelects",
            "setFlashsaleCreateDialogVisible",
            "setFlashsaleCreateStopRequested",
            "setFlashsaleLoadRunning",
            "setFlashsaleLoadStatusText",
            "patchFlashsaleLoadPageInfo",
            "resetFlashsaleLoadPageInfo",
            "bumpFlashsaleLoadGen",
            "setFlashsaleLoadStopFlag",
            "appendFlashsaleProducts",
            "setFlashsaleSelectedShopIds",
            "setFlashsaleShopScanCache",
            "clearFlashsaleShopScanCache",

        ]),
        ...mapActions("product", ["getDetailProduct", 'updateState', 'getDetailProductByApi', "stopCaiJiPddProduct", "startCaiJiPddProduct", "startReadLWXProduct", "startReadPddZipProduct", "startReadPddProduct", "startReadProduct", "startCopyProduct", 'updateProductDetail', "getShopList", "getTemplateList", "runFlashsaleCreate", "startTitleProductsLoad", "stopTitleProductsLoad", "startBatchScopeProductsLoad", "stopBatchScopeProductsLoad"]),
        update_filed_value(path, value, type = "reset") {
            this.UPDATE_FILED_VALUE({ path, value, type })
        },
        show_image_select(filed, type = 'reset') {
            this.SHOW_IMAGE_SELECT_AND_SET_FILED({ filed, type });
        },
        // 图片前缀（alicdn 已有 _sum/_NxN 等后缀时先剥再拼，避免缩略图 404 灰块）
        fillImagePre(url) {
            return fillAlicdnImagePre(url, this.moreConfig?.showImagesType ?? 0);
        },
    },
}